import { ConversationMessageFeedback } from "models/interfaces/conversations/conversation-message-feedback";
import { Record } from "immutable";

const defaultValues: ConversationMessageFeedback = {
    conversationId: undefined,
    feedbackId: undefined,
    messageId: undefined,
    rating: undefined,
    feedbackCategory: undefined,
    feedbackComment: undefined,
};

export default class ConversationMessageFeedbackRecord
    extends Record(defaultValues)
    implements ConversationMessageFeedback
{
    // Do NOT set properties on immutable records due to babel and typescript transpilation issue
    // See https://github.com/facebook/create-react-app/issues/6506

    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: Partial<ConversationMessageFeedback>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    // #endregion Constructor

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------
    /**
     * Merges new values into the record and returns a new instance.
     *
     * @param {Partial<ConversationMessageFeedback>} values
     */
    public with(
        values: Partial<ConversationMessageFeedback>
    ): ConversationMessageFeedbackRecord {
        return new ConversationMessageFeedbackRecord(
            Object.assign(this.toJS(), values)
        );
    }

    // #endregion Public Methods
}
